import React, { Component } from "react";
import { IconButton, IconStar } from "@rdc-npm/rdc-ui";
import style from "./styles";

export default class Loader extends Component {
  render() {
    return (
      <>
        <style jsx>{style}</style>

        <div
          id="agent_search_loading_container"
          className="full-screen-overlay agent-search-loading-container">
          <div className="loading-text">
            <IconButton
              aria-label="add to favorites"
              gutter={{
                bottom: "0",
                left: "auto",
                right: "auto",
                top: "0",
              }}
              isLoading
              size="lg"
              styleType="primary">
              <IconStar />
            </IconButton>
            {/* <i className="fa fa-repeat fa-spin"></i> */}
          </div>
        </div>
      </>
    );
  }
}
